module.exports = __webpack_public_path__ + "img/trial3-2.2d767e1a.png";